import { useLocationIntegrationStatus } from 'app/hooks/useLocationIntegrationStatus'

/** Which agents the workspace has, from the practice's own products. */
export function useAgentAccess(): { loading: boolean; voice: boolean; sms: boolean } {
  const voice = useLocationIntegrationStatus([], `AI Agent`)
  const sms = useLocationIntegrationStatus([], `SMS Agent`)
  return {
    loading: voice.isLoading || sms.isLoading,
    voice: voice.locationOptions.length > 0,
    sms: sms.locationOptions.length > 0,
  }
}
